import * as queries from 'src/graphql/queries'

export const projectsByTenantIdBasic = /* GraphQL */ `
  query ProjectsByTenantIdBasic(
    $tenantId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectsByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        projectType
        isSubTeam
        projectGroup
        parentCompanyId
        projectNumber
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
    }
  }
`

const quotesByTenantIdBasic = /* GraphQL */ `
  query QuotesByTenantIdBasic(
    $tenantId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotesByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        quoteNumber
        assignedTenantId
        assignedTenantName
        isExpired
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
    }
  }
`

export const customQueries = {
	...queries,
	projectsByTenantIdBasic,
	quotesByTenantIdBasic,
}
